import React, {
  useEffect,
  useState
} from "react";

import BaseURL from "../../assets/utils/baseUrl";

import useDocumentTitle from "../../assets/utils/useDocumentTitle";

import {
  Breadcrumb,
  Footer,
  Header,
  Sidebar
} from "../../components";

import {
  useLocation,
  useParams
} from "react-router-dom";

function AgendaDetail() {

  useDocumentTitle(
    "Agenda - BAPENDA BEKASI"
  );

  // =========================
  // PARAM
  // =========================

  const { id } = useParams();

  const location =
    useLocation();

  // =========================
  // STATE
  // =========================

  const [informasi,
    setInformasi] =
    useState(null);

  const [loading,
    setLoading] =
    useState(true);

  // =========================
  // FETCH DATA
  // =========================

  const secureUrl = (url) => {
  if (!url) return "";

  return url.replace("http://", "https://");
};

  useEffect(() => {

    const controller =
      new AbortController();

    const getData =
      async () => {

        try {

          setLoading(true);

          const response =
            await fetch(

              BaseURL +
              "index.php/api/Agenda?id=" +
              id,

              {
                method: "GET",

                headers: {
                  Accept:
                    "application/json",

                  "Content-Type":
                    "application/json",

                  // API KEY
                  "X-API-KEY":
                    process.env
                      .REACT_APP_API_KEY
                },

                signal:
                  controller.signal
              }
            );

          // =========================
          // VALIDASI RESPONSE
          // =========================

          if (!response.ok) {

            throw new Error(
              "HTTP Error " +
              response.status
            );
          }

          const result =
            await response.json();

          console.log(
            "DETAIL AGENDA:",
            result
          );

          // =========================
          // VALIDASI DATA
          // =========================

          if (
            result &&
            result.status === true &&
            Array.isArray(
              result.data
            ) &&
            result.data.length > 0
          ) {

            setInformasi(
              result.data[0]
            );

          } else {

            setInformasi(null);
          }

        } catch (error) {

          if (
            error.name !==
            "AbortError"
          ) {

            console.error(
              "ERROR AGENDA:",
              error
            );
          }

          setInformasi(null);

        } finally {

          setLoading(false);
        }
      };

    if (id) {

      getData();
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    return () =>
      controller.abort();

  }, [id, location]);

  // =========================
  // RENDER KONTEN
  // =========================

  const renderKonten =
    () => {

      if (
        !informasi?.konten
      ) {

        return (
          <p className="informasi-detail-desc">
            Tidak ada konten
          </p>
        );
      }

      return informasi.konten

        .split("(_newline)")

        .filter(
          (item) =>
            item.trim() !== ""
        )

        .map(
          (
            item,
            index
          ) => (

            <p
              className="informasi-detail-desc"

              key={index}
            >

              {item}

            </p>
          )
        );
    };

  // =========================
  // LOADING
  // =========================

  if (loading) {

    return (

      <div className="page">

        <Header active="publikasi" />

        <div
          style={{
            padding: "40px",
            textAlign: "center"
          }}
        >
          Loading...
        </div>

        <Footer />

      </div>
    );
  }

  // =========================
  // DATA TIDAK ADA
  // =========================

  if (!informasi) {

    return (

      <div className="page">

        <Header active="publikasi" />

        <div
          style={{
            padding: "40px",
            textAlign: "center"
          }}
        >
          Data agenda tidak ditemukan
        </div>

        <Footer />

      </div>
    );
  }

  // =========================
  // RENDER
  // =========================

  return (

    <div className="page">

      <Header active="publikasi" />

      <main className="main-sb">

        <section className="content">

          <Breadcrumb
            path={
              informasi.judul ||
              "Agenda"
            }

            parent="agenda"
          />

          <div className="informasi-detail-wrapper">

            {/* ========================= */}
            {/* TITLE */}
            {/* ========================= */}

            <p className="informasi-detail-title">

              {
                informasi.judul ||
                "-"
              }

            </p>

            {/* ========================= */}
            {/* DATE */}
            {/* ========================= */}

            <p className="informasi-detail-date">

              {
                informasi.created_date ||
                "-"
              }

              {" | "}

              {
                informasi.nama ||
                "-"
              }

            </p>

            {/* ========================= */}
            {/* IMAGE */}
            {/* ========================= */}

           <div className="informasi-detail-image-wrapper">

<img
  src={
    informasi?.thumbnail
      ? secureUrl(
          informasi.thumbnail.startsWith("http")
            ? informasi.thumbnail
            : BaseURL +
              "assets/images/agenda/" +
              informasi.thumbnail
        )
      : "/no-image.png"
  }
  className="informasi-detail-image"
  alt={
    informasi?.judul ||
    "agenda"
  }
  loading="lazy"
  onError={(e) => {
    console.log(
      "IMAGE ERROR:",
      e.target.src
    );

    e.target.src =
      "/no-image.png";
  }}
/>

</div>

            {/* ========================= */}
            {/* CONTENT */}
            {/* ========================= */}

            <div className="informasi-detail-desc-wrapper">

              {renderKonten()}

            </div>

          </div>

        </section>

        <Sidebar />

      </main>

      <Footer />

    </div>
  );
}

export default AgendaDetail;